import React, { Component } from "react";
import Layout from "./Layout";
import axios from "axios";
import PropagateLoader from "react-spinners/PropagateLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEdit,
  faTrash,
  faPlusCircle,
  faPencilAlt,
  faUser,
  faBriefcase,
  faFingerprint,
  faPortrait,
  faMapMarkedAlt,
  faPhone,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import {
  Row,
  Col,
  Tab,
  Nav,
  ListGroup,
  Table
} from "react-bootstrap";
import ReacTooltip from "react-tooltip";
import { NavLink } from "react-router-dom";

export default class Escritorio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      datos: [],
    };
  }

  componentDidMount = () => {
    this.cargaDatos();
  };

  cargaDatos = () => {
    let uuid = this.props.match.params.uuid
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "https://contraloria.tepic.gob.mx/si/ws/expediente/?uuid=" +
        uuid +
        "&api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ datos: res.data, loading: false });
    });
  };

  render() {
    return (
      <div>
        <Layout>
          <div
            id="cargando"
            className={this.state.loading ? "parentDisable" : ""}
            width="100%"
          >
            <div className="overlay-box">
              <PropagateLoader
                // css={}
                sizeUnit={"px"}
                size={25}
                color={"#000000"}
                loading={this.state.loading}
              />
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="container">
            <Row className="card-perfil">


              <Col xs="12">
                <Row>
                  <Col xs="12" md="2">
                    <div className="text-center">
                      <a href={this.state.datos.img ? this.state.datos.img.fotografia : ""} target="_blank">
                        <img src={this.state.datos.img ? this.state.datos.img.fotografia : ""} alt="Fotografia" className="img-thumbnail img-perfil"></img>
                      </a>
                    </div>
                  </Col>
                  <Col xs="12" md="10">
                    <Row>
                      <Col xs="12">
                        <h3>{this.state.datos.data ? this.state.datos.data.nombre + " " + this.state.datos.data.primer_ap + " " + this.state.datos.data.segundo_ap + " / " + this.state.datos.data.rfc : ""} </h3>
                      </Col>
                      <Col xs="12" md="12">
                        <h4><FontAwesomeIcon icon={faBriefcase} /> {this.state.datos.puesto ? this.state.datos.puesto.unidad_responsable : ""} / {this.state.datos.puesto ? this.state.datos.puesto.direccion : ""} / {this.state.datos.puesto ? this.state.datos.puesto.puesto : ""} / {this.state.datos.puesto ? this.state.datos.puesto.fecha_ingreso : ""}</h4>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Tab.Container id="left-tabs-example" defaultActiveKey="dos">
                <Col xs="12" md="2">
                  <Nav variant="pills" className="flex-column">

                    <Nav.Item>
                      <Nav.Link className="nav-link-tab" eventKey="dos">Datos Personales</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="nav-link-tab" eventKey="tres">Documentos</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="nav-link-tab" eventKey="cuatro">Estudios</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="nav-link-tab" eventKey="cinco">Curriculum</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="nav-link-tab" eventKey="seis">Huella y Firma</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs="12" md="10">
                  <Tab.Content>
                    <Tab.Pane eventKey="uno">
                      <Row>
                        <Col xs="12" md="4">
                          <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faBriefcase} /> Puesto</h2>
                          <span className="titulos_perfil">UR:</span>
                          <h5>
                            {this.state.datos.puesto ? this.state.datos.puesto.unidad_responsable : ""}
                          </h5>
                          <span className="titulos_perfil">Dirección:</span>
                          <h5>
                            {this.state.datos.puesto ? this.state.datos.puesto.direccion : ""}
                          </h5>
                          <span className="titulos_perfil">Puesto:</span>
                          <h5>
                            {this.state.datos.puesto ? this.state.datos.puesto.puesto : ""}
                          </h5>
                          <span className="titulos_perfil">Funciones:</span>
                          <h5>
                            {this.state.datos.puesto ? this.state.datos.puesto.funciones : ""}
                          </h5>
                          <span className="titulos_perfil">Fecha Ingreso:</span>
                          <h5>
                            {this.state.datos.puesto ? this.state.datos.puesto.fecha_ingreso : ""}
                          </h5>
                        </Col>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="dos">
                      <Row>
                        <Col xs="12" md="4">
                          <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faUser} /> Datos Personales</h2>
                          <span className="titulos_perfil">Nombre:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.nombre : ""}
                          </h5>
                          <span className="titulos_perfil">Primer Apellido:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.primer_ap : ""}
                          </h5>
                          <span className="titulos_perfil">Segundo Apellido:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.segundo_ap : ""}
                          </h5>
                          <span className="titulos_perfil">Fecha de Nacimiento:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.fecha_nac : ""}
                          </h5>
                          <span className="titulos_perfil">RFC:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.rfc : ""}
                          </h5>
                          <span className="titulos_perfil">CURP:</span>
                          <h5>
                            {this.state.datos.data ? this.state.datos.data.curp : ""}
                          </h5>
                        </Col>
                        <Col xs="12" md="4">
                          <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faMapMarkedAlt} /> Dirección</h2>
                          <span className="titulos_perfil">Calle:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.calle : ""}
                          </h5>
                          <span className="titulos_perfil">No. Ext:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.num_ext : ""}
                          </h5>
                          <span className="titulos_perfil">No. Int:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.num_int : ""}
                          </h5>
                          <span className="titulos_perfil">Colonia:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.colonia : ""}
                          </h5>
                          <span className="titulos_perfil">CP:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.cp : ""}
                          </h5>
                          <span className="titulos_perfil">Municipio:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.municipio : ""}
                          </h5>
                          <span className="titulos_perfil">Estado:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.estado : ""}
                          </h5>
                          <span className="titulos_perfil">Pais:</span>
                          <h5>
                            {this.state.datos.direccion ? this.state.datos.direccion.pais : ""}
                          </h5>
                        </Col>
                        <Col xs="12" md="4">
                          <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faPhone} /> Contacto</h2>
                          <span className="titulos_perfil">Correo electronico:</span>
                          <h5>
                            {this.state.datos.contacto ? this.state.datos.contacto.correo_electronico : ""}
                          </h5>
                          <span className="titulos_perfil">Telefono Casa:</span>
                          <h5>
                            {this.state.datos.contacto ? this.state.datos.contacto.tel_casa : ""}
                          </h5>
                          <span className="titulos_perfil">Celular</span>
                          <h5>
                            {this.state.datos.contacto ? this.state.datos.contacto.tel_celular : ""}
                          </h5>
                        </Col>
                      </Row>

                    </Tab.Pane>
                    <Tab.Pane eventKey="tres">
                      <ListGroup>
                        {this.state.datos.files ?
                          this.state.datos.files.map((el) => {
                            if (el.nombre != "Comprobante de Estudio") {
                              return (
                                <ListGroup.Item action href={el.url} target="_blank" key={el.url}>
                                  <span className="perfil-pdf"><FontAwesomeIcon icon={faFilePdf} /></span>{el.nombre}
                                </ListGroup.Item>
                              )
                            }
                          })
                          : null
                        }
                      </ListGroup>
                    </Tab.Pane>
                    <Tab.Pane eventKey="cuatro">
                      <Table bordered size="sm" className="tabla-perfil">
                        <thead>
                          <tr>
                            <th>Nivel</th>
                            <th>Institución Educativa</th>
                            <th>Carrera o Área de Conocimiento</th>
                            <th>Estatus</th>
                            <th>Doc. Obtenido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.datos.estudios ?
                            this.state.datos.estudios.map((el) => {
                              return (
                                <tr>
                                  <td>{el.nivel}</td>
                                  <td>{el.institucion}</td>
                                  <td>{el.carrera}</td>
                                  <td>{el.estatus}</td>
                                  <td>
                                    <a href={"https://contraloria.tepic.gob.mx/si/ws/expediente/file/?id=" + el.id_usr_estudios + "&uuid=" + this.props.match.params.uuid} target="_blank">
                                      <span className="perfil-pdf">
                                        <FontAwesomeIcon icon={faFilePdf} />
                                      </span>
                                      {el.documento_obtenido}
                                    </a>
                                  </td>
                                </tr>
                              )
                            })
                            : null
                          }
                        </tbody>
                      </Table>
                    </Tab.Pane>
                    <Tab.Pane eventKey="cinco">
                      <Table bordered size="sm" className="tabla-perfil">
                        <thead>
                          <tr>
                            <th>Sector</th>
                            <th>Nombre Empresa</th>
                            <th>Area</th>
                            <th>Puesto</th>
                            <th>Descripción</th>
                            <th>Periodo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.datos.laboral ?
                            this.state.datos.laboral.map((el) => {
                              return (
                                <tr>
                                  <td>{el.sector}</td>
                                  <td>{el.nombre_empresa}</td>
                                  <td>{el.area}</td>
                                  <td>{el.puesto}</td>
                                  <td>{el.descripcion}</td>
                                  <td>{el.ingreso} - {el.egreso}</td>
                                </tr>
                              )
                            })
                            : null
                          }
                        </tbody>
                      </Table>
                    </Tab.Pane>
                    <Tab.Pane eventKey="seis">
                      <Row>
                        <Col xs="12" md="4">
                          <span className="titulos_perfil">Huella:</span>
                          <div className="text-center">
                            <a href={this.state.datos.img ? this.state.datos.img.huella : ""} target="_blank">
                              <img src={this.state.datos.img ? this.state.datos.img.huella : ""} alt="huella" class="img-thumbnail"></img>
                            </a>
                          </div>
                        </Col>
                        <Col xs="12" md="4">
                          <span className="titulos_perfil">Firma:</span>
                          <div className="text-center">
                            <a href={this.state.datos.img ? this.state.datos.img.firma : ""} target="_blank">
                              <img src={this.state.datos.img ? this.state.datos.img.firma : ""} alt="firma" class="img-thumbnail"></img>
                            </a>
                          </div>
                        </Col>
                        <Col xs="12" md="4">
                          <span className="titulos_perfil">Antefirma:</span>
                          <div className="text-center">
                            <a href={this.state.datos.img ? this.state.datos.img.antefirma : ""} target="_blank">
                              <img src={this.state.datos.img ? this.state.datos.img.antefirma : ""} alt="antefirma" class="img-thumbnail"></img>
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>

              </Tab.Container>

              {/*
                <Col xs="12" md="4">
                  <Row>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faPortrait} /> Fotografia</h2>
                      <div className="text-center">
                        <img src={this.state.datos.img ? this.state.datos.img.fotografia : ""} alt="Fotografia" class="img-thumbnail"></img>
                      </div>
                    </Col>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faFingerprint} /> Huella y Firma</h2>
                      <span className="titulos_perfil">Huella:</span>
                      <div className="text-center">
                        <img src={this.state.datos.img ? this.state.datos.img.huella : ""} alt="huella" class="img-thumbnail" width="217"></img>
                      </div>
                      <span className="titulos_perfil">Firma:</span>
                      <div className="text-center">
                        <img src={this.state.datos.img ? this.state.datos.img.firma : ""} alt="firma" class="img-thumbnail" width="217"></img>
                      </div>
                      <span className="titulos_perfil">Antefirma:</span>
                      <div className="text-center">
                        <img src={this.state.datos.img ? this.state.datos.img.antefirma : ""} alt="antefirma" class="img-thumbnail" width="217"></img>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col xs="12" md="4">
                  <Row>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faUser} /> Datos Personales</h2>
                      <span className="titulos_perfil">Nombre:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.nombre : ""}
                      </h5>
                      <span className="titulos_perfil">Primer Apellido:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.primer_ap : ""}
                      </h5>
                      <span className="titulos_perfil">Segundo Apellido:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.segundo_ap : ""}
                      </h5>
                      <span className="titulos_perfil">Fecha de Nacimiento:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.fecha_nac : ""}
                      </h5>
                      <span className="titulos_perfil">RFC:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.rfc : ""}
                      </h5>
                      <span className="titulos_perfil">CURP:</span>
                      <h5>
                        {this.state.datos.data ? this.state.datos.data.curp : ""}
                      </h5>
                    </Col>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faMapMarkedAlt} /> Dirección</h2>
                      <span className="titulos_perfil">Calle:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.calle : ""}
                      </h5>
                      <span className="titulos_perfil">No. Ext:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.num_ext : ""}
                      </h5>
                      <span className="titulos_perfil">No. Int:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.num_int : ""}
                      </h5>
                      <span className="titulos_perfil">Colonia:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.colonia : ""}
                      </h5>
                      <span className="titulos_perfil">CP:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.cp : ""}
                      </h5>
                      <span className="titulos_perfil">Municipio:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.municipio : ""}
                      </h5>
                      <span className="titulos_perfil">Estado:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.estado : ""}
                      </h5>
                      <span className="titulos_perfil">Pais:</span>
                      <h5>
                        {this.state.datos.direccion ? this.state.datos.direccion.pais : ""}
                      </h5>
                    </Col>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faPhone} /> Contacto</h2>
                      <span className="titulos_perfil">Correo electronico:</span>
                      <h5>
                        {this.state.datos.contacto ? this.state.datos.contacto.correo_electronico : ""}
                      </h5>
                      <span className="titulos_perfil">Telefono Casa:</span>
                      <h5>
                        {this.state.datos.contacto ? this.state.datos.contacto.tel_casa : ""}
                      </h5>
                      <span className="titulos_perfil">Celular</span>
                      <h5>
                        {this.state.datos.contacto ? this.state.datos.contacto.tel_celular : ""}
                      </h5>
                    </Col>
                  </Row>
                </Col>

                <Col xs="12" md="4">
                  <Row>
                    <Col xs="12">
                      <h2 className="titulos_perfil_seccion"><FontAwesomeIcon icon={faBriefcase} /> Puesto</h2>
                      <span className="titulos_perfil">UR:</span>
                      <h5>
                        {this.state.datos.puesto ? this.state.datos.puesto.unidad_responsable : ""}
                      </h5>
                      <span className="titulos_perfil">Dirección:</span>
                      <h5>
                        {this.state.datos.puesto ? this.state.datos.puesto.direccion : ""}
                      </h5>
                      <span className="titulos_perfil">Puesto:</span>
                      <h5>
                        {this.state.datos.puesto ? this.state.datos.puesto.puesto : ""}
                      </h5>
                      <span className="titulos_perfil">Funciones:</span>
                      <h5>
                        {this.state.datos.puesto ? this.state.datos.puesto.funciones : ""}
                      </h5>
                      <span className="titulos_perfil">Fecha Ingreso:</span>
                      <h5>
                        {this.state.datos.puesto ? this.state.datos.puesto.fecha_ingreso : ""}
                      </h5>
                    </Col>
                  </Row>
                </Col>
              */}
            </Row>
          </div>

        </Layout >
      </div >
    );
  }
}
